export default __webpack_public_path__ + "static/media/web_hosting.93b67b8a.png";